.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content {
  padding: 0 2rem;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  background-color: #1c1c1c;
  color: white;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header h2,
.header p {
  color: white;
  margin: 0;
}

.header-left {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 1rem;
  align-items: center;
}

.header-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 1rem;
  align-items: flex-end;
}

.logo {
  height: 60px;
  margin: 1rem;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.footer {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 1rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  background-color: #1c1c1c;
}

.footer h3,
.footer p,
.footer-list-item {
  color: #fff;
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
}

.footer-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-list-item {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.login-text {
  font-size: 0.9rem;
  color: var(--muted-text);
}

.login-text a {
  color: var(--primary-color);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
  }

  .header-left {
    flex-direction: column;
  }

  .header-right {
    flex-direction: column;
    align-items: center;
  }

  .footer {
    flex-direction: column;
  }

  .footer-left {
    flex-direction: column;
  }

  .footer-list {
    flex-direction: column;
  }

  .footer-right {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 600px) {
  .header {
    flex-direction: column;
  }

  .header-left {
    flex-direction: column;
  }

  .header-right {
    flex-direction: column;
  }

  .footer {
    flex-direction: column;
  }

  .footer-left {
    flex-direction: column;
  }

  .footer-list {
    flex-direction: column;
  }

  .header h2,
  .header p,
  .footer h3,
  .footer p,
  .footer-list-item,
  .footer-list {
    text-align: center;
  }
}

@media print {
  .header {
    position: static;
  }

  .header h2,
  .header p,
  .footer h3,
  .footer p,
  .footer-list-item {
    color: black;
    text-align: center;
  }

  .footer {
    page-break-before: always;
  }

  .footer h3,
  .footer p,
  .footer-list-item {
    color: black;
  }
}
